<td-file-input [(ngModel)]="value"
               [multiple]="multiple"
               [disabled]="disabled"
               [accept]="accept"
               [color]="defaultColor"
               (select)="handleSelect($event)">
  <ng-content></ng-content>
</td-file-input>